document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll(
    '.ctr-hero-banner-bundle, .ctr-hero-banner-bundle-v2, .ctr-hero-banner-bundle-v3'
  );

  sections.forEach(function (section) {
    const videos = section.querySelectorAll('.lazy-video');

    videos.forEach(function (video) {
      if (video.dataset.srcScroll) {
        video.src = video.dataset.srcScroll;
      }

      video.muted = true;
      video.playsInline = true;

      video.addEventListener('loadeddata', function () {
        video.classList.add('loaded');
      });

      const playVideo = function () {
        if (video.paused) {
          video.play().catch(function () {});
        }
      };

      if (video.hasAttribute('autoplay')) {
        playVideo();
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playVideo();
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(video);
    });
  });
});
